'use client'

import { TextButton } from "@/shared/ui/atoms"
import { useRouter } from "next/navigation"
import { useLocale, useTranslations } from "next-intl"

const FooterButtons = () => {
  const router = useRouter()
  const locale = useLocale()
  const t = useTranslations()
  const moveToEntryPage = () => {
    router.push(`/${locale}/entry-form`)
  }
  
  return (
    <div className="flex items-center justify-start gap-2 mb-[30px]">
      <TextButton
        onClick={moveToEntryPage}
        text={t("commonFooter.hospitalEntry")}
        size={12}
        className="cursor-pointer font-medium leading-[18px] text-[#46474C] underline decoration-skip-ink-none underline-offset-[3px]"
      />
    </div>
  )
}

export default FooterButtons
